if (!window.hasInitializedScrollingBands) {
  
    window.hasInitializedScrollingBands = true;

    let scrollingBands = document.querySelectorAll('.scrolling-band__slider');

    scrollingBands.forEach((scrollingBand) => {
      
        const scrollingBandsItemsContainer = scrollingBand.querySelector('.scrolling-band__items');
        
        const directChildren = scrollingBandsItemsContainer.children;
        for (let i = 0; i < directChildren.length; i++) {
            directChildren[i].classList.add('item');
        }
    
        const scrollingBandsItems = scrollingBand.querySelectorAll('.item');
        const scrollingBandSpeed = parseInt(scrollingBand.getAttribute('data-scrolling-speed'), 10) || 20;
        
        if (scrollingBandsItems.length > 0) {
            const duplicationCount = 20;
            for (let y = 0; y < duplicationCount; y++) {
                scrollingBandsItems.forEach((initialItem) => {
                    const clonedItem = initialItem.cloneNode(true);
                    scrollingBandsItemsContainer.appendChild(clonedItem);
                });
            }
        }

        let transformScrollingGradientHeadband = 0;

        function updateTransformScrollingGradientHeadband() {
            transformScrollingGradientHeadband -= 1;

            if (Math.abs(transformScrollingGradientHeadband) >= scrollingBandsItemsContainer.scrollWidth / 2) {
                transformScrollingGradientHeadband = 0;
            }

            scrollingBandsItemsContainer.style.transform = `translateX(${transformScrollingGradientHeadband}px)`;
        }

        setInterval(updateTransformScrollingGradientHeadband, scrollingBandSpeed);
    });
}